module.exports = "//img1.rrcimg.com/_next/static/src/assets/404_Ydjus.png";